// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.cover-image {\n    margin-bottom: 50px;\n    width: 100%;\n    height: 400px;\n}\n.in-btn {\n    margin-left: 30px;\n    padding-left: 30px;\n    padding-right: 30px;\n}\n.custom-select:focus {\n    box-shadow: none !important;\n    border: 1px solid #ced4da;\n}\n", ""]);
// Exports
module.exports = exports;
